import React, { createContext, useContext, useState, useEffect } from 'react';

// we'll keep the raw width in context so callers can derive
// whatever breakpoint makes sense for them.
const MobileContext = createContext({ width: typeof window !== 'undefined' ? window.innerWidth : 0 });

export const MobileProvider = ({ children }) => {
    const [width, setWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth : 0
    );

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return <MobileContext.Provider value={{ width }}>{children}</MobileContext.Provider>;
};

/**
 * Hook that returns a boolean indicating whether the current viewport
 * width is less than or equal to the passed breakpoint (default 768).
 *
 * This keeps the component logic very small - consumers only call
 * `const isMobile = useMobile();` or `useMobile(600)` etc.
 */
export const useMobile = (breakpoint = 768) => {
    const { width } = useContext(MobileContext);
    return width <= breakpoint;
};
